// @flow weak

import React, {
  PureComponent
} from 'react';
import PropTypes from 'prop-types';
import AnimatedView from '../../components/animatedView/AnimatedView';
import BackToTop from '../../components/backToTop/BackToTop';
import { Link, button } from 'react-router-dom';
import Modal from 'react-modal';
import Item from '../item/Item';
import Tree from '../tree/Tree';


class Images extends PureComponent {
  static propTypes = {
    // react-router 4:
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,

    // views:
    currentView: PropTypes.string.isRequired,
    enterAbout: PropTypes.func.isRequired,
    leaveAbout: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    var keyword = (props.match.params.keyword) ? props.match.params.keyword : null;
    jQuery('#fbc-found').text("-");
    jQuery('#fbc-currentCnt').text("-");

    this.state = {
      item: [],
      images: [],
      xhrPool: [],
      start: 0,
      processingCount: 0,
      modalIsOpen: false,
      album: (props.match.params.album) ? props.match.params.album : null,
      keyword: keyword,
      isLoadFinish: false,
    };

    this.getItem = this.getItem.bind(this);
    this.handleScroll = this.handleScroll.bind(this);

    if (props.location.state) {
      var name = (props.location.state.albumName) ? props.location.state.albumName : "Main Library";
      jQuery('#fbc-res').text("Album:");
      jQuery('#fbc-album').text(name);
    }
    if (keyword) {
      jQuery('#fbc-res').text("Search:");
      jQuery('#fbc-album').text(keyword);
    }

  }

  componentWillReceiveProps(newProps) {
    var self = this;
    jQuery('#fbc-found').text("-");
    jQuery('#fbc-currentCnt').text("-");

    $.each(self.state.xhrPool, function (idx, jqXHR) {
      jqXHR.abort();
    });

    var album = newProps.match.params.album;
    var keyword = newProps.match.params.keyword;

    var name = "Main Library";
    var text = newProps.location.state;
    if (text) {
      var name = (newProps.location.state.albumName) ? newProps.location.state.albumName : "Main Library";
    }
    jQuery('#fbc-res').text("Album:");
    jQuery('#fbc-album').text(name);

    if (keyword) {
      jQuery('#fbc-res').text("Search:");
      jQuery('#fbc-album').text(keyword);
    }

    this.setState({
      item: [],
      images: [],
      xhrPool: [],
      album: album,
      keyword: keyword,
      start: 0,
      modalIsOpen: false,
      processingCount: 0,
      isLoadFinish: false,
    }, () => {
      this.getList();
    });
  }

  componentDidMount() {
    const { enterAbout } = this.props;
    enterAbout();

    window.addEventListener("scroll", this.handleScroll);

    this.getList();
  }

  componentWillUnmount() {
    const { leaveAbout } = this.props;
    leaveAbout();
    window.removeEventListener("scroll", this.handleScroll);

  }

  setResults(album, found) {
    jQuery('#fbc-album').text(album);
    jQuery('#fbc-found').text(found);
  }

  getList() {
    jQuery('#loader').show();
    jQuery('#scroll-to-load').hide();

    var self = this;
    self.setState({ isLoadFinish: false });

    var start = (this.state.start > 0) ? this.state.start : 0;
    // var album = (this.state.album != null) ? "&album=" + this.state.album : "";
    var album = (this.state.album != null) ? this.state.album : "";
    // var keyword = (this.state.keyword != null) ? "&keyword=" + this.state.keyword : "";
    var keyword = (this.state.keyword != null) ? this.state.keyword : "";
    var uri = args.FBC_URL + "includes/lib/get.php?subdomain=" + args.subdomain + "&app_api="
      + args.app_api + "&token=" + args.token + album + keyword + "&limit=60&start=" + start + "&wp_abspath=" + args.abspath;

    $.ajax({
      // url: uri,
      beforeSend: function (jqXHR, settings) {
        self.state.xhrPool.push(jqXHR);
      },
      url: args.FBC_URL + "includes/lib/get.php?subdomain=" + args.subdomain,
      type: "POST",
      dataType: 'json',
      data: {
        subdomain: args.subdomain,
        app_api: args.app_api,
        token: args.token,
        album: album,
        keyword: keyword,
        limit: 60,
        start: start,
        wp_abspath: args.abspath,
      },
    })
      .done(function (result) {
        var data = JSON.parse(result);
        var count = (data && data.found) ? data.found : 0;
        jQuery('#fbc-found').text(count);
        // var cnt = 0;
        self.setState({
          items: data.results,
          found: data.found,
        });
        if (data.found > 0) {
          $.each(data.results, function (k, v) {
            self.getImages(v, data.results.length, data.found);
          });
        } else {
          jQuery('#loader').hide();
          jQuery('#fbc-found').text(0);
          jQuery('#fbc-currentCnt').text(0);
        }
      });
  }

  getImages(item, length, found) {
    var self = this;

    // let docImg = args.FBC_URL + '/assets/document-icon.png';
    // var directUrl = (item.scheme == 'image' || item.scheme == 'video' || item.scheme == 'audio') ? item.url.directUrlPreview : docImg;
    var directUrl800 = item.url.directUrlPreview;
    var directUrl320 = directUrl800.slice(0, -3) + '320';

    var image = {
      "id": item.id,
      "scheme": item.scheme,
      "name": item.name,
      "owner": item.owner,
      "ownerName": item.ownerName,
      "size": item.size,
      "time": item.time,
      "directUrlPreview": directUrl320,
      "directUrlDetail": directUrl800,
      "description": item.description,
      "directUrlOriginal": item.url.directUrlOriginal,
      "preview":item.url.preview,
    };

    var arr = self.state.images.slice();
    arr.push(image);
    self.setState({ images: arr });

    var currentCount = self.state.processingCount + 1;
    jQuery('#fbc-currentCnt').text(currentCount);
    self.setState({ processingCount: currentCount });
    if (currentCount == (self.state.start + length)) {
      jQuery('#loader').hide();
      if (currentCount != found) {
        jQuery('#scroll-to-load').show();
        self.setState({ isLoadFinish: true });
      }

      self.setState({ start: currentCount });
    }

    // });
  }

  getItem(item) {
    this.setState({
      item: item,
      modalIsOpen: true
    });
  }

  handleModal(e) {
    this.setState({
      modalIsOpen: e
    });
  }

  handleScroll() {
    var self = this;
    let zoom = self.detectZoom();

    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = (windowHeight + window.pageYOffset) / (zoom / 100);

    if (windowBottom >= docHeight && this.state.isLoadFinish) {
      this.getList();
    }
  }

  handleChange(e) {
  }

  detectZoom() {
    var ratio = 0,
      screen = window.screen,
      ua = navigator.userAgent.toLowerCase();

    if (window.devicePixelRatio !== undefined) {
      ratio = window.devicePixelRatio;
    }
    else if (~ua.indexOf('msie')) {
      if (screen.deviceXDPI && screen.logicalXDPI) {
        ratio = screen.deviceXDPI / screen.logicalXDPI;
      }
    }
    else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
      ratio = window.outerWidth / window.innerWidth;
    }

    if (ratio) {
      ratio = Math.round(ratio * 100);
    }

    return ratio;
  }


  render() {
    const modal = (this.state.modalIsOpen) ? <Item item={this.state.item} modalIsOpen={true} handleModal={this.handleModal.bind(this)} /> : '';

    return (
      <AnimatedView>
        {modal}
        <div className="attachments row" id="__attachments-view-fbc">
          {this.state.images.map((item, index) => (
            <div className="col-lg-2 col-md-3 col-sm-4 col-xs-6" style={{ opacity: "1", height: "190px", paddingLeft: "0px" }} onClick={this.getItem.bind(this, item)} key={index}>
              {/* <div className="canto-attachment-preview" style={{ opacity: '0.9', backgroundImage: "url(" + item.img + ")", position: "absolute", width: "100%" }}>
                <div className="filename">{item.name}</div>
              </div> */}
              <div className="canto-attachment-preview">
                <img
                  alt={item.name}
                  src={item.directUrlPreview}
                  // src={item.directUrlOriginal}
                  className={"canto-image"}
                />
              </div>
            </div>
          ))}
        </div>

        <div id="scroll-to-load">
          <button onClick={this.getList.bind(this)}>
            <i className="fa fa-chevron-down"></i> Click or scroll down to load more
          </button>
        </div>

        <BackToTop
          minScrollY={40}
          scrollTo={'fbc-react'}
        />
      </AnimatedView>
    );
  }
}

export default Images;



// WEBPACK FOOTER //
// ./src/app/views/images/Images.js